export default {
  online_payments_off:
    'La livraison est activée, mais les clients ne peuvent pas la commander : la livraison par coursier se paie uniquement en ligne, et les paiements en ligne sont désactivés.',
  gateway_not_verified:
    'La livraison est activée, mais les clients ne peuvent pas la commander : la livraison par coursier se paie uniquement en ligne, et les paiements en ligne sont suspendus tant que votre compte de paiement n’est pas vérifié.',
  stripe_processing_fee_missing:
    'La livraison est activée, mais les clients ne peuvent pas la commander : la livraison par coursier se paie uniquement en ligne, et les paiements en ligne sont suspendus tant que votre partenaire n’a pas défini ses frais de traitement.',
  turn_on_online_payments: 'Activer les paiements en ligne',
};
